import { FaBriefcase, FaCalendarAlt, FaChalkboardTeacher, FaDollarSign, FaHeart, FaLightbulb, FaShieldAlt, FaTrophy, FaUsers, FaWallet } from 'react-icons/fa';
import { images } from '../constants'; 

const careerIntro = {
    sub: "Join Our Security Experts",
    heading: "Enhance Security with Cutting-Edge Technology",
    description: "At Secura, we're dedicated to providing advanced security solutions that protect people and property. We're looking for passionate individuals to join our team and make a difference by developing and delivering top-notch CCTV and security systems.",
    points: [
        {
            icon: <FaShieldAlt />,
            text: "Innovative Security Solutions"
        },
        {
            icon: <FaDollarSign />,
            text: "Competitive Compensation"
        },
        {
            icon: <FaUsers />,
            text: "Collaborative Teamwork"
        },
        {
            icon: <FaBriefcase />,
            text: "Career Development Opportunities"
        },
        {
            icon: <FaHeart />,
            text: "Make a Difference"
        }
    ],
};

const benefits = [
    {
        id: 1,
        title: "Career Growth",
        description: "We prioritize your career development by offering opportunities to grow within the security and surveillance industry.",
        icon: <FaTrophy /> // Trophy Icon
    },
    {
        id: 2,
        title: "Ongoing Training",
        description: "We provide hands-on training and certifications in the latest CCTV technologies and security systems, ensuring you stay ahead of industry trends.",
        icon: <FaChalkboardTeacher /> // Training Icon
    },
    {
        id: 3,
        title: "Attractive Salary",
        description: "We offer competitive salaries, comprehensive benefits, and incentives based on your contributions to our security solutions and company success.",
        icon: <FaWallet /> // Wallet Icon
    },
    {
        id: 4,
        title: "Work-Life Flexibility",
        description: "Enjoy a flexible work schedule with remote work options, allowing you to maintain a healthy work-life balance while delivering high-quality security solutions.",
        icon: <FaCalendarAlt /> // Calendar Icon
    },
    {
        id: 5,
        title: "Collaborative Culture",
        description: "Work alongside industry professionals in a supportive, collaborative environment where your ideas help shape the future of security technologies.",
        icon: <FaUsers /> // Users Icon
    },
    {
        id: 6,
        title: "Impactful Work",
        description: "Make a meaningful impact by contributing to security solutions that protect people and property, all while working with a purpose-driven team.",
        icon: <FaLightbulb /> // Lightbulb Icon
    },
];

const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'CCTV Installation Technician',
        content: 'Join our team to install and maintain high-quality CCTV and security systems, ensuring safety and reliability.',
        details: {
            location: 'On-site',
            timing: 'Full Time',
            hours: 'Standard Working Hours',
            experience: 'Minimum 2 Years in CCTV Installation',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$40K - $55K/year',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join our team as a CCTV Installation Technician! You will be responsible for installing, configuring, and maintaining security systems to ensure optimal performance and reliability. This role offers an exciting opportunity to work on-site and contribute to enhancing safety and surveillance solutions.',
        ],
        responsibilities: [
            'Install, configure, and maintain CCTV and security systems.',
            'Conduct system testing and troubleshooting for performance optimization.',
            'Ensure proper wiring and connectivity for surveillance equipment.',
            'Collaborate with clients to understand security needs and provide solutions.',
            'Perform routine maintenance and system upgrades as needed.',
        ],
        qualifications: [
            'Proven experience in CCTV installation and maintenance.',
            'Knowledge of surveillance systems, wiring, and troubleshooting.',
            'Ability to work independently and on-site at various locations.',
            'Strong technical and problem-solving skills.',
            'Familiarity with security system software and networking basics.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Security Systems Engineer',
        content: 'Design, implement, and maintain advanced security systems to ensure safety, reliability, and cutting-edge protection.',
        details: {
            location: 'Remote/On-site',
            timing: 'Full Time',
            hours: 'Flexible Working Hours',
            experience: 'Minimum 3 Years in Security Systems Engineering',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$80K - $100K/year',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join our team as a Security Systems Engineer! You will be responsible for designing, implementing, and maintaining advanced security systems that protect people and property. This role offers the flexibility of working remotely or on-site, making it a great opportunity for experienced security professionals.',
        ],
        responsibilities: [
            'Develop and implement security system architectures and solutions.',
            'Integrate security hardware and software for optimal performance.',
            'Analyze vulnerabilities and enhance system protections.',
            'Work closely with clients to customize security solutions.',
            'Provide technical support and troubleshooting for security systems.',
        ],
        qualifications: [
            'Proven experience in security systems engineering and implementation.',
            'Strong knowledge of CCTV, access control, and alarm systems.',
            'Familiarity with network security and cybersecurity principles.',
            'Ability to work both remotely and on-site as needed.',
            'Excellent problem-solving and technical troubleshooting skills.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'CCTV Maintenance Specialist',
        content: 'Ensure the optimal performance and longevity of CCTV systems through regular maintenance, troubleshooting, and repairs.',
        details: {
            location: 'On-site',
            timing: 'Full Time',
            hours: 'Standard Working Hours',
            experience: 'Minimum 2 Years in CCTV Maintenance',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$45K - $60K/year',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join our team as a CCTV Maintenance Specialist! In this role, you will be responsible for the upkeep and repair of CCTV systems, ensuring they function efficiently and reliably. This is a great opportunity for skilled technicians to work on-site and contribute to maintaining high-quality security solutions.',
        ],
        responsibilities: [
            'Perform routine maintenance and servicing of CCTV systems.',
            'Diagnose and repair faults in cameras, DVRs, and related equipment.',
            'Ensure system firmware and software are up to date.',
            'Collaborate with the security team to optimize surveillance coverage.',
            'Provide technical support and training on CCTV operation.',
        ],
        qualifications: [
            'Proven experience in CCTV system maintenance and repair.',
            'Strong troubleshooting and problem-solving skills.',
            'Familiarity with different CCTV brands and configurations.',
            'Ability to work on-site and respond to maintenance requests quickly.',
            'Basic knowledge of networking and video surveillance protocols.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Security Consultant',
        content: 'Provide expert security advice and risk assessments to help clients implement effective security solutions and policies.',
        details: {
            location: 'Remote',
            timing: 'Full Time',
            hours: 'Flexible Working Hours',
            experience: 'Minimum 3 Years in Security Consulting',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$70K - $90K/year',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join our team as a Security Consultant! In this role, you will be responsible for assessing security risks, designing security solutions, and advising clients on best practices to enhance their security posture. This is an excellent opportunity for experienced professionals to work remotely and make a meaningful impact in the security industry.',
        ],
        responsibilities: [
            'Conduct security assessments and risk analysis for clients.',
            'Develop and recommend security strategies and best practices.',
            'Advise on security system implementations, policies, and protocols.',
            'Stay updated on emerging security threats and technologies.',
            'Collaborate with clients to ensure compliance with security regulations.',
        ],
        qualifications: [
            'Proven experience in security consulting and risk assessment.',
            'Strong knowledge of security systems, protocols, and compliance standards.',
            'Excellent communication and problem-solving skills.',
            'Ability to work independently and provide remote consulting services.',
            'Certifications such as CISSP, CISM, or equivalent are a plus.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Security Software Developer',
        content: 'Develop and enhance security software solutions to protect systems, networks, and applications from cyber threats.',
        details: {
            location: 'Remote',
            timing: 'Full Time',
            hours: 'Flexible Working Hours',
            experience: 'Minimum 3 Years in Security Software Development',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$85K - $110K/year',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join our team as a Security Software Developer! You will be responsible for designing, developing, and implementing security software solutions to safeguard applications and networks against cyber threats. This is an exciting opportunity to work remotely and contribute to innovative security technologies.',
        ],
        responsibilities: [
            'Develop and maintain security-focused software applications.',
            'Implement security protocols and encryption techniques.',
            'Identify and address software vulnerabilities and threats.',
            'Collaborate with security teams to ensure best practices are followed.',
            'Stay updated on emerging cybersecurity trends and technologies.',
        ],
        qualifications: [
            'Proven experience in security software development.',
            'Strong programming skills in Python, C++, or Java.',
            'Familiarity with cybersecurity principles and best practices.',
            'Experience with penetration testing and vulnerability assessments.',
            'Ability to work independently and remotely.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'Network Security Specialist',
        content: 'Protect and enhance network security by implementing advanced cybersecurity measures and threat mitigation strategies.',
        details: {
            location: 'Remote/On-site',
            timing: 'Full Time',
            hours: 'Flexible Working Hours',
            experience: 'Minimum 3 Years in Network Security',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$75K - $95K/year',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'We are looking for a skilled Network Security Specialist to secure and optimize our network infrastructure. You will be responsible for implementing security measures, monitoring threats, and ensuring compliance with cybersecurity standards. Join our team and help defend against evolving cyber threats.',
        ],
        responsibilities: [
            'Develop and implement network security policies and protocols.',
            'Monitor network traffic and detect potential security breaches.',
            'Conduct risk assessments and vulnerability scans.',
            'Collaborate with IT teams to enhance security measures.',
            'Stay updated on the latest cybersecurity threats and solutions.',
        ],
        qualifications: [
            'Proven experience in network security and threat management.',
            'Strong knowledge of firewalls, IDS/IPS, and encryption protocols.',
            'Familiarity with compliance standards such as ISO 27001 and NIST.',
            'Experience with security incident response and mitigation.',
            'Ability to work independently and in a team environment.',
        ],
    }

];




export { positions, benefits, careerIntro };